import { Pressable, StyleSheet } from "react-native";

const SimplePress = ({style, onPress, children, disabled, hitSlop }) => {
  return (
    <Pressable
      hitSlop={hitSlop}
      disabled={disabled}
      onPress={onPress}
      style={({ pressed }) => pressed?[style,styles.pressedItem]:style}
    >
      {children}
    </Pressable>
  );
};

export default SimplePress;

const styles = StyleSheet.create({
  pressedItem: {
    opacity: 0.5,
  },
});
